import {
    Box,
    Grid,
    Skeleton,
    Stack,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";

interface ISelectGuestsSkeletonProps {
    maxGuests?: number;
    showAlert?: boolean;
}

const SelectGuestsSkeleton = ({ maxGuests = 8 }: ISelectGuestsSkeletonProps) => {
    return (
        <Stack px={ThemeSpaceVariable.Medium} spacing={ThemeSpaceVariable.None} width="full">
            {/* Header skeleton */}
            <Skeleton
                height={ThemeFontSizeVariable.X2Large}
                width="60%"
                mb={ThemeSpaceVariable.Medium}
            />

            {/* Introduction text skeleton */}
            <Stack mt={ThemeSpaceVariable.Medium} mb={ThemeSpaceVariable.Large}>
                <Skeleton height={ThemeFontSizeVariable.Medium} width="90%" />
                <Skeleton height={ThemeFontSizeVariable.Medium} width="75%" />
                <Skeleton height={ThemeFontSizeVariable.Medium} width="85%" />
            </Stack>

            {/* Guest selection buttons grid */}
            <Box width="100%">
                <Grid templateColumns="repeat(4, 1fr)" gap={ThemeSpaceVariable.Small} width="100%">
                    {Array.from({ length: Math.min(maxGuests, 8) }).map((_, index) => (
                        <Skeleton
                            key={index}
                            height={ThemeSpaceVariable.XLarge}
                            width="100%"
                            borderRadius={ThemeSpaceVariable.Small}
                        />
                    ))}
                </Grid>
            </Box>
        </Stack>
    );
};

export default SelectGuestsSkeleton;
